// Environment-based configuration
// Vite exposes VITE_* variables via import.meta.env.
// Set them in .env.local for local dev; they are injected at Docker build time for production.

export const API_CONFIG = {
  BASE_URL:        import.meta.env.VITE_API_BASE_URL        || 'https://api.echohire.in/api',
  STATIC_BASE_URL: import.meta.env.VITE_STATIC_BASE_URL     || 'https://api.echohire.in',
  PROCTORING_URL:  import.meta.env.VITE_PROCTORING_URL      || 'https://procter.echohire.in',
};

export const APP_CONFIG = {
  APP_NAME:      'Interview AI Platform',
  VERSION:       '2.0.0',
  SUPPORT_EMAIL: 'info@echohire.in',
};

export const FEATURES = {
  ENABLE_AUDIO_RECORDING:          true,
  ENABLE_VIDEO_RECORDING:          false,
  ENABLE_REAL_TIME_TRANSCRIPTION:  true,
  ENABLE_AI_ANALYSIS:              true,
};

const config = { API_CONFIG, APP_CONFIG, FEATURES };
export default config;
